import { Component, inject } from "@angular/core";
import { MAT_SNACK_BAR_DATA } from "@angular/material/snack-bar";

@Component({
    selector: "inspekt-snack-bar",
    templateUrl: "./snack-bar.component.html",
    styleUrls: ["./snack-bar.component.css"],
    imports: [],
})
export class SnackBarComponent {
    data = inject(MAT_SNACK_BAR_DATA);
}
